var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDialog',{attrs:{"propDialog":_vm.dialog,"max-width":400,"title":`${_vm.invoice.tableName} - ${_vm.invoice.customerName}`,"actionable":false},on:{"closeDialog":_vm.setDialog}},[_c('div',{staticClass:"d-flex justify-center"},[(_vm.$socket.connected)?_c('VueQr',{attrs:{"text":_vm.invoiceLink}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }